import OpenbetLogger from 'openbet-logger';

export class GCMLoader {
    constructor() {
        this._logger = new OpenbetLogger('GCMLoader');
    }

    init() {
        const path = '/gcm/gcm-launcher/';
        const baseURL = (window.location.protocol + '//' + window.location.host).concat(path);
        const launcherJsUrl = new URL(baseURL.concat('js/dist/launcher.min.js'));
        const configUrl = new URL(baseURL.concat('config/gcmConfig.json'));
        const translationsUrl = new URL(baseURL.concat('config/gcmTranslations.json'));
        const params = new URL(window.location.href).searchParams;

        if (params.has('src_version')) {
            const version = params.get('src_version');
            configUrl.searchParams.append('gcmVersion', version);
        }

        const timestamp = Math.floor(Date.now() / 1000).toString();
        configUrl.searchParams.append('cb', timestamp);
        launcherJsUrl.searchParams.append('cb', timestamp);
        translationsUrl.searchParams.append('cb', timestamp);

        this.loadJSON(configUrl.href).then((config) => {
            if (config.ok) {
                this.loadJS(launcherJsUrl.href, (result) => {
                    if (result) {
                        this.loadJSON(translationsUrl.href).then((translations) => {
                            gcmLaunch.launcher.init(config.data, translations?.data); // eslint-disable-line no-undef
                        });
                    }
                });
            }
        });
    }

    loadJS(strUrl, callback) {
        if (strUrl) {
            this.addServiceScript(strUrl).then(
                (result) => {
                    callback(result);
                },
                (err) => {
                    this._logger.error('Error loading JS\n', err);
                    callback(undefined);
                }
            );
        }
    }

    async loadJSON(url) {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) {
            this._logger.error('Error loading JSON: ', res);
            return { ok: false, error: res };
        }
        try {
            const data = await res.json();
            return { ok: true, data };
        } catch (e) {
            return { ok: false, error: e };
        }
    }

    addServiceScript(scriptUrl) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptUrl;
            script.addEventListener('load', () => resolve(script), false);
            script.addEventListener('error', () => reject(script), false);
            document.body.appendChild(script);
        });
    }
}

export const loader = new GCMLoader();
